import { Controller } from 'stimulus';
import gsap from 'gsap';
import localDb from '../helpers/localDb';
import dataLayer from '../tracking/dataLayer';

const CLOSE_TTL_IN_MINUTES = 60 * 3;
const CLOSE_KEY = 'vacancy-reminder';

class VacancyReminder extends Controller {
  connect() {
    if (localDb.get(CLOSE_KEY) === null) {
      this.showReminder();
      this.setA11yExpanded();
    }
  }

  setA11yExpanded(value = 'true') {
    this.element.setAttribute('aria-expanded', value);
    this.closeTarget.setAttribute('aria-expanded', value);
  }

  showReminder() {
    this.element.style.opacity = 0;
    this.element.style.display = 'block';

    gsap.to(this.element, {
      opacity: 1,
    });
  }

  // eslint-disable-next-line class-methods-use-this
  moveFocus() {
    const mainElement = document.getElementById('main');

    if (!mainElement) {
      document.body.focus();
      return;
    }

    mainElement.focus();
  }

  onLinkClick() {
    dataLayer.event('VacancyReminder', 'click', this.data.get('id'));
    this.markClosed();
  }

  onCloseClick(event) {
    this.markClosed();

    gsap.to(this.element, {
      autoAlpha: 0,
    });

    this.setA11yExpanded('false');

    // Only move focus to main element if keyboard Enter is used.
    if (event.keyCode === 13) {
      this.moveFocus();
    }
  }

  // eslint-disable-next-line class-methods-use-this
  markClosed() {
    localDb.set(CLOSE_KEY, true, CLOSE_TTL_IN_MINUTES);
  }
}

VacancyReminder.targets = [
  'close',
];

export default VacancyReminder;
